<template>
  <v-dialog v-model="dialog" width="500" style="padding: 0px 8px;">
    <template v-slot:activator="{ on }">
      <v-btn color="mdred lighten-1" dark v-on="on">
        {{ soft ? $t("app.buttons.deactivate") : $t("app.buttons.delete") }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline mdred lighten-1 white--text" primary-title>
        {{ $t("app.dialogs.are-you-sure") }}
      </v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined @click="dialog = false">
          {{ $t("app.buttons.cancel") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn dark color="mdred lighten-1" @click="remove">
          {{ $t("app.buttons.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    soft: Boolean,
    endpoint: {
      type: String,
      required: true
    }
  },

  data: () => ({
    dialog: false
  }),

  methods: {
    remove() {
      this.$http
        .delete(this.endpoint, {
          withCredentials: true,
          credentials: "include",
          mode: "cors"
        })
        .then(request => this.deleteSuccessful(request.data))
        .catch(error => this.deleteFailed(error));
    },

    deleteSuccessful(req) {
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "success",
          message: this.$t("app.actions.success.delete")
        },
        { root: true }
      );
      this.$emit("deleted");
    },

    deleteFailed(error) {
      if (process.env.NODE_ENV !== "production") {
        console.log(error);
      }
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "success",
          message: this.$t("app.actions.deletion")
        },
        { root: true }
      );
    }
  }
};
</script>
